import styled, { css } from 'styled-components';

import { mediaQuery, Button } from '@catalyze/ui';

export const StyledForm = styled.form`
    width: 100%;
    margin-top: 1rem;
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
    ${mediaQuery(
        2,
        css`
            margin-top: 2rem;
        `
    )}
`;

export const StyledButton = styled(Button)`
    margin: 0 auto;
    width: 10.375rem;
    ${mediaQuery(
        2,
        css`
            width: 14.75rem;
        `
    )}
`;

export const ErrorMessage = styled.p`
    text-align: center;
    margin: 0 auto;
    width: 15rem;
    color: ${({ theme }) => theme.colors.formError};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;
